const WalletActionButtonAddBalanceModalSelectPrice = ({
  price,
  onSetPrice,
  walletPlanItems,
}) => {
  const updatePrice = (amount) => {
    onSetPrice(amount);
  };

  return (
    <div className="flex flex-wrap items-center justify-center sm:gap-3 2xm:gap-0 gap-4 md:mb-8 mb-8">
      {walletPlanItems.length > 0
        ? walletPlanItems.map((items) => (
            <button
              key={items.id}
              onClick={() => updatePrice(items.real_price)}
              className={`${
                price === items.real_price && "!border-primary " 
              }bg-white shadow-custom-lg border border-gray-300/60 text-primary rounded-lg px-3 py-1.5 3xm:text-base text-sm hover:border-primary duration-300 transition-colors`}
            >
              {items.real_price.toLocaleString("fa")} تومان
            </button>
          ))
        : "پلنی برای شارژ یافت نشد با پشیتبانی تماس بگیرید !"}
    </div>
  );
};

export default WalletActionButtonAddBalanceModalSelectPrice;
